import classNames from "classnames"
import React, { useRef, useState, useEffect } from "react"
import { create } from "zustand"

import Logo from "./Icons/YocoLogoIcon"

interface SplashState {
  animationDone: boolean
  setAnimationDone: (done: boolean) => void
}

export const useSplashStore = create<SplashState>()((set) => ({
  animationDone: false,
  setAnimationDone: (done: boolean) => set({ animationDone: done }),
}))

const Splash = () => {
  const { animationDone, setAnimationDone } = useSplashStore()
  const [loaded, setLoaded] = useState(false)
  const splashWrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleAnimationEnd = () => setAnimationDone(true)

    if (splashWrapperRef.current) {
      splashWrapperRef.current.addEventListener(
        "animationend",
        handleAnimationEnd,
        { passive: true }
      )
    }

    setLoaded(true)

    return () => {
      if (splashWrapperRef.current) {
        splashWrapperRef.current.removeEventListener(
          "animationend",
          handleAnimationEnd
        )
      }
    }
  }, [])

  return !animationDone ? (
    <div
      ref={splashWrapperRef}
      className={classNames("splash-wrapper", { animated: loaded })}
    >
      <div className="relative flex h-full w-full items-center justify-center">
        <div className={classNames("splash", { animated: loaded })}></div>
        <Logo
          className={classNames("splash-image absolute fill-white", {
            animated: loaded,
          })}
        />
      </div>
    </div>
  ) : null
}

export default Splash
